import styled from '@emotion/styled';
import { Button, Stack, Typography, colors } from '@ui-components/neo.tax';
import { ReactComponent as GoogleIcon } from '@ui-components/neo.tax/dist/icons/google.svg';
import { ReactComponent as IntuitIcon } from '@ui-components/neo.tax/dist/icons/intuit.svg';
import { ReactComponent as MicrosoftIcon } from '@ui-components/neo.tax/dist/icons/microsoft.svg';

const ssoIconStyle = {
  color: colors.gray[500],
  display: 'inline-block',
  height: '1.25rem',
  marginRight: '1.5rem',
};

export const StyledGoogleIcon = styled(GoogleIcon)(ssoIconStyle);

export const StyledMicrosoftIcon = styled(MicrosoftIcon)(ssoIconStyle);

export const StyledIntuitIcon = styled(IntuitIcon)(ssoIconStyle);

export const StyledSsoButton = styled(Button)({
  color: colors.gray[700],
  flexGrow: '1',
  margin: '0 0 0.25rem 0',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  justifyContent: 'normal',
});

export const StyledSsoButtonContainer = styled(Stack)({
  marginTop: '0.25rem',
});

export const StyledSsoTitle = styled(Typography)({
  color: colors.gray[700],
});
